import { render, staticRenderFns } from "./RegularSlide.vue?vue&type=template&id=cd7f6bc2&scoped=true&"
import script from "./RegularSlide.vue?vue&type=script&lang=js&"
export * from "./RegularSlide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd7f6bc2",
  null
  
)

export default component.exports